import { render, staticRenderFns } from "./MovingFromAddressFormPart.vue?vue&type=template&id=0e189a2b"
import script from "./MovingFromAddressFormPart.vue?vue&type=script&lang=js"
export * from "./MovingFromAddressFormPart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports